const { Pagination, Button } = require("antd");

const TablePagination = ({ page, paginationData, changePage, changeSize }) => {
  return (
    <>
      <div className="flex justify-center mt-4">
        <Pagination
          total={paginationData.total}
          showTotal={(total) => `Нийт ${total} бичлэг`}
          pageSize={paginationData.size}
          current={page}
          onChange={changePage}
          onShowSizeChange={changeSize}
          showSizeChanger
          size="default"
          className="custom-ant-pagination"
          showQuickJumper
          itemRender={(page, type, originalElement) => {
            if (type === "prev") {
              return (
                <Button
                  shape="circle"
                  size="small"
                  className="!border-none !shadow-none"
                  icon={<span>&lt;</span>}
                />
              );
            }
            if (type === "next") {
              return (
                <Button
                  shape="circle"
                  size="small"
                  className="!border-none !shadow-none"
                  icon={<span>&gt;</span>}
                />
              );
            }
            return originalElement;
          }}
        />
      </div>
      <style>
        {`
          .custom-ant-pagination .ant-pagination-item-active {
            background: linear-gradient(90deg,rgb(209, 233, 225) 0%,rgb(234, 244, 242) 100%);
            border-color:rgb(142, 208, 210);
            color: #fff;
          }
          .custom-ant-pagination .ant-pagination-item {
            border-radius: 50%;
            min-width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 4px;
            font-weight: 500;
            color:#fff;
            transition: background 0.2s;
          }
          .custom-ant-pagination .ant-pagination-item:hover {
            background: #e6f7ff;
            color:rgb(235, 238, 235);
          }
          .custom-ant-pagination .ant-pagination-prev,
          .custom-ant-pagination .ant-pagination-next {
            border-radius: 50%;
            min-width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 4px;
          }
        `}
      </style>
    </>
  );
};
export default TablePagination;
